import { ApexOptions } from "apexcharts";
import { FacebookMetric, GoogleMetric, SitewideMetric } from "services/CompareService";
import { FACEBOOK_METRIC_FORMATTERS, FACEBOOK_METRIC_LABELS, GOOGLE_METRIC_FORMATTERS, GOOGLE_METRIC_LABELS, SITEWIDE_METRIC_FORMATTERS, SITEWIDE_METRIC_LABELS } from "../types/SelectTypes";

export const baseChartOptions: ApexOptions = {
  chart: {
    type: "line",
    toolbar: {
      show: false,
    },
    stacked: false,
  },
  tooltip: {
    theme: "dark",
    shared: true,
    intersect: false,
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
    width: 3,
  },
  xaxis: {
    type: "datetime",
    labels: {
      style: {
        colors: "#fff",
      },
      format: 'dd MMM',
      datetimeFormatter: {
        year: 'yyyy',
        month: 'MMM yyyy',
        day: 'dd MMM',
        hour: 'HH:mm',
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    title: {
      text: "",
      style: {
        color: "#fff",
      },
    },
    labels: {
      style: {
        colors: "#fff",
      },
      formatter: (value: number) => value.toFixed(2),
    },
  },
  grid: {
    strokeDashArray: 5,
    borderColor: "#56577A",
  },
  legend: {
    show: true,
    position: "top",
    horizontalAlign: "left",
    labels: {
      colors: "#fff",
    },
  },
  fill: {
    type: "solid",
    opacity: 1,
  },
};

export const facebookChartOptions: ApexOptions = {
  ...baseChartOptions,
  chart: {
    ...baseChartOptions.chart,
    group: "facebook_charts",
  },
  colors: ["#FF6B6B", "#1CE4E5"],
  tooltip: {
    ...baseChartOptions.tooltip,
    y: {
      formatter: (value: number, { seriesIndex, w }: any) => {
        const metric = w.config.series[seriesIndex].metric as FacebookMetric;
        return FACEBOOK_METRIC_FORMATTERS[metric](value);
      },
    },
  },
};

export const sitewideChartOptions: ApexOptions = {
  ...baseChartOptions,
  chart: {
    ...baseChartOptions.chart,
    group: "sitewide_charts",
  },
  colors: ["#D9FD4F", "#1CE4E5"],
  tooltip: {
    ...baseChartOptions.tooltip,
    y: {
      formatter: (value: number, { seriesIndex, w }: any) => {
        const metric = w.config.series[seriesIndex].metric as SitewideMetric;
        return SITEWIDE_METRIC_FORMATTERS[metric](value);
      },
    },
  },
};

export const getFacebookChartOptions = (selectedMetric: FacebookMetric): ApexOptions => {
  return {
    ...facebookChartOptions,
    yaxis: {
      title: {
        text: FACEBOOK_METRIC_LABELS[selectedMetric],
        style: {
          color: "#fff",
        },
      },
      labels: {
        style: {
          colors: "#fff",
        },
        formatter: (value: number) => FACEBOOK_METRIC_FORMATTERS[selectedMetric](value),
      },
    },
  };
};

export const googleChartOptions: ApexOptions = {
  ...baseChartOptions,
  chart: {
    ...baseChartOptions.chart,
    group: "google_charts",
  },
  colors: ["#34A853", "#1CE4E5"],
  tooltip: {
    ...baseChartOptions.tooltip,
    y: {
      formatter: (value: number, { seriesIndex, w }: any) => {
        const metric = w.config.series[seriesIndex].metric as GoogleMetric;
        return GOOGLE_METRIC_FORMATTERS[metric](value);
      },
    },
  },
};

export const getGoogleChartOptions = (selectedMetric: GoogleMetric): ApexOptions => {
  return {
    ...googleChartOptions,
    yaxis: {
      title: {
        text: GOOGLE_METRIC_LABELS[selectedMetric],
        style: {
          color: "#fff",
        },
      },
      labels: {
        style: {
          colors: "#fff",
        },
        formatter: (value: number) => GOOGLE_METRIC_FORMATTERS[selectedMetric](value),
      },
    },
  };
};

export const getSitewideChartOptions = (selectedMetric: SitewideMetric): ApexOptions => {
  return {
    ...sitewideChartOptions,
    yaxis: {
      title: {
        text: SITEWIDE_METRIC_LABELS[selectedMetric],
        style: {
          color: "#fff",
        },
      },
      labels: {
        style: {
          colors: "#fff",
        },
        formatter: (value: number) => SITEWIDE_METRIC_FORMATTERS[selectedMetric](value),
      },
    },
  };
};
